import ItemInput from "./ItemInput";
import PageHeader from "./PageHeader";
import BusyOverlay from "./BusyOverlay";
import OnboardingTooltip from "./OnboardingTooltip";
import Sort from "./Sort";

const commonComponents = {
  ItemInput,
  PageHeader,
  BusyOverlay,
  OnboardingTooltip,
  Sort
}

export default commonComponents